var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:DRIVERS",arg:"DRIVERS"}],key:_vm.switch1},[_c('loading-component',{attrs:{"value":_vm.loading}}),_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.CAPTAINS,"enable-edit":false,"enable-add":false,"enable-delete":false,"formatter":_vm.formatters,"actions-extra-main":_vm.actionsExtraMain,"perPage":"25","fields-hidden-main":[
      'updated_at',
      'deleted_at',
      'blacklisted_at',
      'blacklist_note',
      'account_state',
      'profile_image',
      'status',
      'full_name',
      'notification_token',
      'birthday',
      'avg_rating',
      'email',
      'nationality_id',
      'license_number'
    ],"titles":_vm.titles,"title":_vm.$t("captainsPage.pendingDriversTitle"),"initial-url-search-params":_vm.pendingParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }